import React, { useState, useEffect } from 'react';
import TableFilterTemplate from '../../shared/utils/TableFilterTemplate';
import { useGetAllActivityLms } from '../../assets/nodeApi/getApi/getAdminApi';
import { IconButton, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';

const ActiveViewlms = () => {
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });
    const [searchQuery, setSearchQuery] = useState('');
    const [debouncedSearchQuery, setDebouncedSearchQuery] = useState('');

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearchQuery(searchQuery);
            setPaginationModel(prev => ({ ...prev, page: 0 }));
        }, 500);
        return () => clearTimeout(handler);
    }, [searchQuery]);

    const queryParams = {
        page: paginationModel.page + 1,
        limit: paginationModel.pageSize,
        ...(debouncedSearchQuery ? { search: debouncedSearchQuery } : {})
    };

    const { data: activeLmsData, isLoading: isActiveLmsLoading } = useGetAllActivityLms(queryParams);
    const navigate = useNavigate();

    const activeLmsRowsList = Array.isArray(activeLmsData?.data) 
        ? activeLmsData?.data 
        : (activeLmsData?.data?.data || activeLmsData?.data?.records || activeLmsData?.data?.rows || []);

    // Map rows with unique ID and formatted properties
    const activeLmsRows = activeLmsRowsList?.map((item, index) => ({
        id: item.course_id, // Setting the row ID to course_id to simplify detail navigation
        sr_no: (paginationModel.page * paginationModel.pageSize) + index + 1,
        ...item
    })) ?? [];

    const totalRows = activeLmsData?.pagination?.totalElements || activeLmsData?.pagination?.total || activeLmsData?.total || activeLmsData?.data?.total || activeLmsRowsList?.length || 0;

    const activeLmsColumns = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 0.5,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>
        },
        {
            field: "course_name",
            headerName: "Course Name",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>
        },
        {
            field: "grade_name",
            headerName: "Grade",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>
        },
        {
            field: "status",
            headerName: "Status",
            flex: 1,
            renderCell: (params) => (
                <Typography
                    variant="body2"
                    sx={{
                        textTransform: 'capitalize',
                        color: params.value === 'active' ? 'success.main' : 'text.secondary',
                        fontWeight: 500
                    }}
                >
                    {params.value}
                </Typography>
            )
        },
        {
            field: "actionsView",
            headerName: "View",
            flex: 0.8,
            renderCell: (params) => (
                <Stack direction="row" spacing={1}>
                    <IconButton
                        onClick={() => {
                            // Navigating to the registered detail route for active LMS activities
                            navigate(`/admin/activtitylms/view/${params?.row?.course_id}?gradeId=${params?.row?.grade_id}`);
                        }}
                        size="small"
                    >
                        <VisibilityIcon color="text.primary" />
                    </IconButton>
                </Stack>
            ),
        },
    ];

    return (
        <TableFilterTemplate
            title="Activity LMS List"
            columns={activeLmsColumns}
            rowsData={activeLmsRows}
            isLoading={isActiveLmsLoading}
            isServerSide={true}
            serverPaginationModel={paginationModel}
            onServerPaginationChange={setPaginationModel}
            onServerSearchChange={setSearchQuery}
            totalServerRows={totalRows}
        />
    );
};

export default ActiveViewlms;

